import React from "react";

function AboutSection() {
  return (
    <section id="about" className="about-section">
      <div className="about-text-heading container">
        <h2>
          Who is <span className="nowrap">Shalu Ambasta?</span>
        </h2>
      </div>
      <div className="about-text-content container">
        <h3 className="about-text">
          A curiosity-driven Front-End Developer with design chops From India.
        </h3>
        <p className="about-text">
          I'm passionate about bringing both the technical and visual aspects of
          digital products to life.
        </p>
        <p className="about-text">
          I'm Pursuing B.Tech in Computer Science and Engineering from Gaya
          College of Engineering.
        </p>
        <p className="about-text">
          I'm happiest when I'm creating, learning, exploring and thinking about
          how to make things better.
        </p>
        <p className="about-text">
          Apart from Programming; I also have a very sweet tooth 🍯, I love
          being surrounded by nature 🌴, doing glass painting, doodling with my
          paint brush 🖌, experimenting to cook new dishes 👩‍🍳, and spending time
          with my birdie 🦜.
        </p>
      </div>
    </section>
  );
}

export default AboutSection;
